const LdJsonGallery = ({ content, url, imgList, sections, sectionUrl }) => {

    const domain = process.env.NEXT_PUBLIC_DOMAIN_URL || 'https://www.ellitoral.com';
    const absoluteUrl = url?.startsWith('http') ? url : `${domain}${url}`;

    const { title, description, publishedDate, modificatedAt, keywords, tags } = content;

    const galleryDescription = description || title;

    const associatedMedia = imgList && imgList.length > 0
        ? imgList.map((img, index) => {
            const mediaObj = {
                "@type": "ImageObject",
                "url": img.bigImgUrl,
                "representativeOfPage": index === 0
            };
            if (img.epigraphe) mediaObj.caption = img.epigraphe;
            if (img.author) {
                mediaObj.author = { "@type": "Person", "name": img.author };
                mediaObj.creditText = img.author;
            }
            return mediaObj;
        })
        : [];

    let data = [];

    const LdGallery = {
        "@context": "https://schema.org",
        "@type": "ImageGallery",
        "name": `[Galería] ${title}`,
        "description": galleryDescription,
        "url": absoluteUrl,
        "datePublished": publishedDate,
        "dateModified": modificatedAt,
        "inLanguage": "es-AR",
        "isAccessibleForFree": true,
        "publisher": {
            "@type": "Organization",
            "name": "El Litoral",
            "url": "https://www.ellitoral.com",
            "logo": {
                "@type": "ImageObject",
                "url": `${domain}/img/header_logoellitoral.svg`,
                "width": 439,
                "height": 60
            }
        },
        "copyrightHolder": { "@type": "Organization", "name": "El Litoral" },
        "copyrightYear": publishedDate ? publishedDate.split('-')[0] : new Date().getFullYear().toString()
    };

    if (imgList && imgList.length > 0) LdGallery.image = imgList[0].bigImgUrl;
    if (associatedMedia.length > 0) LdGallery.associatedMedia = associatedMedia;
    if (keywords) LdGallery.keywords = keywords;
    if (tags && tags.length > 0) {
        LdGallery.about = tags.map(t => ({ "@type": "Thing", "name": t.name }));
    }

    data.push(LdGallery);

    const imageObjects = imgList && imgList.length > 0
        ? imgList.map(img => ({
            "@type": "ImageObject",
            "url": img.bigImgUrl,
            ...(img.epigraphe && { "caption": img.epigraphe })
        }))
        : [];

    const imageObjectsWithDates = imgList && imgList.length > 0
        ? [{
            "@type": "ImageObject",
            "url": imgList[0].bigImgUrl,
            "width": 1565,
            "datePublished": publishedDate,
            "dateModified": modificatedAt,
            ...(imgList[0].epigraphe && { "caption": imgList[0].epigraphe })
        }]
        : [];

    const LdArticle = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": { "@type": "WebPage", "@id": absoluteUrl },
        "headline": `[Galería] ${title}`,
        "url": absoluteUrl,
        "description": galleryDescription,
        "image": imageObjectsWithDates.length > 0 ? imageObjectsWithDates : undefined,
        "dateCreated": publishedDate,
        "datePublished": publishedDate,
        "dateModified": modificatedAt,
        "isAccessibleForFree": true,
        "inLanguage": "es-AR",
        "citation": { "@type": "CreativeWork", "url": absoluteUrl },
        "articleSection": sections && sections.length > 0 ? sections.map(s => s.name) : [],
        "author": [{
            "@type": "Organization",
            "name": "El Litoral",
            "url": "https://www.ellitoral.com"
        }],
        "isPartOf": {
            "@type": ["CreativeWork", "Product"],
            "name": "El Litoral",
            "url": "https://www.ellitoral.com"
        },
        "publisher": {
            "@type": "Organization",
            "name": "El Litoral",
            "url": "https://www.ellitoral.com",
            "logo": {
                "@type": "ImageObject",
                "url": `${domain}/img/header_logoellitoral.svg`,
                "width": 439,
                "height": 60
            },
            "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://www.youtube.com/c/EllitoralArgentina"]
        },
        "copyrightHolder": { "@type": "Organization", "name": "El Litoral" },
        "copyrightYear": publishedDate ? publishedDate.split('-')[0] : new Date().getFullYear().toString()
    };

    if (keywords) LdArticle.keywords = keywords;
    if (tags && tags.length > 0) {
        LdArticle.about = tags.map(t => ({ "@type": "Thing", "name": t.name }));
    }

    data.push(LdArticle);

    const breadcrumbItems = [
        { "@type": "ListItem", "position": 1, "name": "El Litoral", "item": domain },
        { "@type": "ListItem", "position": 2, "name": "Fotos HD", "item": `${domain}/fotos-hd` }
    ];

    if (sections && sections.length > 0) {
        sections.forEach((section, index) => {
            breadcrumbItems.push({
                "@type": "ListItem",
                "position": index + 3,
                "name": section.name?.toUpperCase(),
                "item": `${domain}${sectionUrl}`
            });
        });
    }

    data.push({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbItems
    });

    data.push({
        "@context": "https://schema.org",
        "@type": "Organization",
        "legalName": "El Litoral",
        "name": "El Litoral",
        "description": "Diario El Litoral, el medio de comunicación de mayor trayectoria de la provincia de Santa Fe. Noticias de Santa Fe, Argentina y el mundo actualizadas las 24 horas.",
        "url": "https://www.ellitoral.com",
        "logo": `${domain}/img/header_logoellitoral.svg`,
        "foundingDate": "1918",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Elizabeth Guillamón de Agnellini 2670",
            "addressLocality": "Santa Fe",
            "addressRegion": "Santa Fe",
            "postalCode": "3000",
            "addressCountry": "AR"
        },
        "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://www.youtube.com/c/EllitoralArgentina"]
    });

    data.push({
        "@context": "https://schema.org",
        "@type": "NewsMediaOrganization",
        "name": "El Litoral",
        "description": "Diario El Litoral, el medio de comunicación de mayor trayectoria de la provincia de Santa Fe. Noticias de Santa Fe, Argentina y el mundo actualizadas las 24 horas.",
        "url": "https://www.ellitoral.com",
        "masthead": "https://www.ellitoral.com/quienes-somos",
        "publishingPrinciples": "https://www.ellitoral.com/quienes-somos",
        "ethicsPolicy": "https://www.ellitoral.com/politicas-privacidad-facebook-news",
        "correctionsPolicy": "https://www.ellitoral.com/politicas-privacidad-facebook-news",
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+543426305344",
            "contactType": "customer service",
            "email": "contenidos@ellitoral.com"
        }
    });

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
};

export default LdJsonGallery;
